import {  MENU_MODULES, SubMenuItem } from "src/constants/modules";

const getMenuItems = (backendModules: { clientId: string; type: string }[]): SubMenuItem[] => {
  const dynamic: SubMenuItem[] = backendModules.flatMap((m) => {
    const def = MENU_MODULES.find((d) => d.type === m.type);
    if (!def) return [];
    return [{  ...def, key: m.clientId}];
  });
  const staticMenuItems: SubMenuItem[] = MENU_MODULES.filter((val) => val.isstatic).map((val) => ({ ...val, key: val.type }));


  return [...dynamic, ...staticMenuItems].sort((a, b) => a.order - b.order);
};


export { getMenuItems};
